import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RWNumberPicker from 'react-widgets/lib/NumberPicker';
import SingleSelectInput from './SingleSelectInput';
import DateTimeInput from './DateTimeInput';

export default class RoomBookingCalendarInput extends Component {
  static propTypes = {
    availableCallback: PropTypes.func.isRequired,
    bookedCallback: PropTypes.func.isRequired,
    dateCallback: PropTypes.func.isRequired,
    durationCallback: PropTypes.func.isRequired,
    locationCallback: PropTypes.func.isRequired,
    locationDefault: PropTypes.string.isRequired,
    locationData: PropTypes.array.isRequired,
    dateDefault: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { minutes: 30, hours: 0 };
  }

  //
  // CALLBACKS
  //

  handleHourChange = (value) => {
    this.setState({ hours: value }, function () {
      this.findDuration();
    });
  }

  handleMinuteChange = (value) => {
    this.setState({ minutes: value }, function () {
      this.findDuration();
    });
  }

  handleEnterKey = (event) => {
    if (event.which === 13) {
      event.preventDefault();
      this.refs.date.getDOMNode().focus();
      this.refs.date.getDOMNode().blur();
    }
  }

  //
  // HELPERS
  //

  findDuration() {
    const totalMinutes = this.state.minutes + (this.state.hours * 60);
    this.props.durationCallback(totalMinutes);
  }

  render() {
    return (
      <div className="Form">
        <div className="u-hintText u-mb-4">Times are displayed in the time zone of the campus</div>
        <div className="md:u-flex md:u-flex-row md:u-justify-between">
          <div className="md:u-w-1/4">
            <span className="hint">Show me</span>
            <ul className="button-group even-2 radius u-ml-0 u-mt-2">
              <li>
                <a className={`Button Button--scope Button--xsmall button${this.props.type === 'available' ? ' is-active' : ''}`}
                   onClick={this.props.availableCallback} role="button"
                >Available</a>
              </li>
              <li>
                <a className={`Button Button--scope Button--xsmall button${this.props.type === 'booked' ? ' is-active' : ''}`}
                   onClick={this.props.bookedCallback} role="button"
                >Booked</a>
              </li>
            </ul>
          </div>
          <div className="md:u-w-1/5">
            <span className="hint">At</span>
            <SingleSelectInput
              data={this.props.locationData}
              defaultValue={this.props.locationDefault}
              textField="name"
              valueField="id"
              name="booking[location]"
              onChange={v => {
                this.props.locationCallback(v.id);
              }
              }
            />
          </div>
          <div className="md:u-w-1/5">
            <span className="hint">On</span>
            <DateTimeInput
              ref="date"
              time={false}
              onKeyPress={this.handleEnterKey}
              defaultValue={this.props.dateDefault}
              onChange={this.props.dateCallback}
              useTimezone={this.props.useTimezone}
            />
          </div>
          <div className="md:u-w-1/4 end" hidden={this.props.type === 'booked'}>
            <div className="NumberPickerContainer">
              <span className="hint">Hours</span>
              <RWNumberPicker
                ref="hours"
                min={0}
                max={24}
                defaultValue={0}
                onChange={this.handleHourChange}
              />
            </div>
            <div className="NumberPickerContainer">
              <span className="hint">Minutes</span>
              <RWNumberPicker
                ref="minutes"
                min={0}
                max={30}
                step={30}
                defaultValue={30}
                onChange={this.handleMinuteChange}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
